import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ShanklistComponents from '../../ShanklistComponents';
class Content extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    // 渲染
    componentsView(mainData) {
        const { noAd } = this.props.content;

        return mainData.map((item, index) => {
            const { data, component, componentOptions } = item;

            if (!(component in ShanklistComponents)) return null;

            return React.createElement(ShanklistComponents[component], {
                key: index,
                componentOptions,
                content: data,
                noAd,
            });
        });
    }

    render() {
        const { mainData } = this.props.content;

        return this.componentsView(mainData);
    }
}

export { Content };
export default Content;
